import { render, staticRenderFns } from "./AboutSection.vue?vue&type=template&id=aa7b888e&scoped=true"
var script = {}
import style0 from "./AboutSection.vue?vue&type=style&index=0&id=aa7b888e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa7b888e",
  null
  
)

export default component.exports